// extracted by mini-css-extract-plugin
module.exports = {"mobile_reset":"Weeks_mobile_reset__mJuKw"};